import { useState } from "react";
import { InView } from "react-intersection-observer";
import posthog from "posthog-js";
import { useQuery } from "@tanstack/react-query";

import useAppSelector from "@/hooks/useAppSelector";
import { recombeeToCart } from "@/utils/product";
import CategoriesSectionProductGallery from "@/components/Organisms/CategoriesSectionProductGallery";
import useSessionContext from "@/hooks/useSesionContext";
import MeiliSearch from "@/recourses/meilisearch/meiliSearch";

const CategoriesPromofit = () => {
  const { isAthenticated } = useSessionContext();
  const storeId = useAppSelector((state) => state.cart.storeId);
  const userID = posthog.get_distinct_id();
  const [inView, setInView] = useState(false);

  const {
    data: bestSellerPromofit,
    error,
    isFetching,
    isFetched,
  } = useQuery({
    queryKey: ["bestSellerPromofitProducts", userID, storeId, isAthenticated()],
    queryFn: async () => {
      const buildFilters = `store_id = ${storeId} AND is_available_online = true AND product_availability_on_sale_online = true AND product_availability_available_online = true`;

      const { hits } = await new MeiliSearch()
        .filter(buildFilters)
        .limit(20)
        .sort(["product_percentage_discount_online:desc"])
        .search();

      const items: Cart[] = [];

      hits
        .sort((itemA, itemB) => {
          const valuesA = itemA;
          const valuesB = itemB;

          return (
            (valuesB?.product_percentage_discount_online ?? 0) -
            (valuesA?.product_percentage_discount_online ?? 0)
          );
        })
        .forEach((recom) => {
          items.push(recombeeToCart(+recom.id, +(storeId ?? 0), recom));
        });
      return {
        items,
      };
    },
    enabled: !!userID && !!storeId && inView,
  });

  if (error) {
    return null;
  }

  if (isFetching || !storeId || !userID || (!inView && !isFetched)) {
    return (
      <InView
        onChange={(isView) => {
          if (!inView) setInView(isView);
        }}
        rootMargin="1500px 0px"
        triggerOnce
      >
        <CategoriesSectionProductGallery items={[]} recommId={""} isLoading />
      </InView>
    );
  }

  if (bestSellerPromofit?.items && bestSellerPromofit?.items.length <= 0) {
    return null;
  }

  return (
    <CategoriesSectionProductGallery
      items={bestSellerPromofit?.items ?? []}
      title={"Promofit"}
      showViewMore
      to="/c/promofit"
    />
  );
};

export default CategoriesPromofit;
